// SessionComplete.js
import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import './SessionComplete.css';

const SessionComplete = ({ 
  score = 0, 
  timeInSeconds = 0,
  onViewResults,
  buttonText = "View results"
}) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    console.log('Loading animation...');
    
    // Play fanfare sound
    const audio = new Audio(process.env.PUBLIC_URL + '/sounds/fanfare_session_complete.mp3');
    audio.play().catch(error => console.error('Failed to play sound:', error));
    
    fetch(process.env.PUBLIC_URL + '/Animation - 1749657318004.json')
      .then(response => {
        console.log('Response:', response);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Animation data loaded:', data);
        setAnimationData(data);
      })
      .catch(error => console.error('Failed to load animation:', error));
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="session-complete-wrapper">
      <div className="session-content">
        {animationData && (
          <div className="celebration-animation">
            <Lottie 
              animationData={animationData} 
              loop={false}
              autoplay={true}
              style={{ width: 400, height: 400 }}
            />
          </div>
        )}
        <h1 className="session-title">Session complete!</h1>
        
        <div className="metrics-grid">
          <div className="metric-card">
            <div className="metric-header">
              <div className="metric-icon">🏆</div>
              <div className="metric-label">Score</div>
            </div>
            <div className="metric-value">{score}%</div>
          </div>

          <div className="metric-card">
            <div className="metric-header">
              <div className="metric-icon">⏱️</div>
              <div className="metric-label">Time</div>
            </div>
            <div className="metric-value">{formatTime(timeInSeconds)}</div>
          </div>
        </div>

        <button className="view-results-button" onClick={onViewResults}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default SessionComplete;